import { render } from "./AiFavorableCommentsDeepLink.vue?vue&type=template&id=3c03f80d&scoped=true"
import script from "./AiFavorableCommentsDeepLink.vue?vue&type=script&lang=js"
export * from "./AiFavorableCommentsDeepLink.vue?vue&type=script&lang=js"

import "./AiFavorableCommentsDeepLink.vue?vue&type=style&index=0&id=3c03f80d&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c03f80d"]])

export default __exports__